<main class="wrapper w-full p-6 flex flex-col gap-6">
  <!-- 상단 헤더 -->
  <header class="flex items-center justify-between min-h-10">
    <h1 class="text-xl font-bold text-base-content flex items-center gap-2">
      <span class="w-1 h-6 rounded-full bg-primary"></span>
      통계 관리
    </h1>
  </header>

  <!-- 통계 유형 탭 -->
  <lepi-filter-tab [options]="tabOptions" [value]="segment()" (tabChange)="segment.set($any($event))" />

  <!-- 차트 영역 -->
  @switch (segment()) {
    @case ('total-visit') {
      <app-total-visit />
    }
    @case ('popular-page') {
      <app-popular-page />
    }
    @case ('incoming-page') {
      <app-incoming-page />
    }
    @case ('device-type') {
      <app-device-type />
    }
  }

  <!-- 방문자 목록 -->
  <lepi-ssp-data-grid
    title="방문자 목록"
    [columns]="columns"
    [rowData]="items()!"
    [pageInfo]="pageInfo()!"
    [(pageNo)]="pageNo"
    [(pageSize)]="pageSize"
    [(orderBy)]="orderBy"
    [(align)]="align"
    [(query)]="query"
    [options]="gridOptions" />
</main>
